import { createSlice } from "@reduxjs/toolkit";
import { IOnetDescription, IStudentCurrentOpeningSlice } from "../../../models/student/studentCareerPath";

const initialStudentCurrentOpeningState: IStudentCurrentOpeningSlice = {
  currentOpeningDetail: undefined,
  jobDescription: undefined
};

const studentCurrentOpeningSlice = createSlice({
  name: "currentOpeningDetail",
  initialState: initialStudentCurrentOpeningState,
  reducers: {
    setStudentCurrentOpening: (state, action: { payload: any }) => {
      state.currentOpeningDetail = action.payload;
    },
    setJobDescription: (state, action: { payload: any }) => {
      if (!Array.isArray(state.jobDescription)) {
        state.jobDescription = [];
      }
      state.jobDescription.push(action.payload);
    },

    clearJobDescription: (state, action: { payload: any }) => {
      state.jobDescription = action.payload;
    },
  },
});

export const { setStudentCurrentOpening, setJobDescription, clearJobDescription } = studentCurrentOpeningSlice.actions;

const studentCurrentOpeningReducer = studentCurrentOpeningSlice.reducer;

export type studentCurrentOpeningState = ReturnType<typeof studentCurrentOpeningReducer>;

export default studentCurrentOpeningReducer;